
# My Life Philosophy

My new life philosophy mirrors the prisoner's dilemma. The normal game theory dilemma is told like this:
- 2 players
- work together and win together
- work alone and someone loses big while someone wins small
- Punnett Square type of system
- choices
  - 00: both lose
  - 01: 1 winner; 1 loser
  - 10: 1 winner; 1 loser
  - 11: both win

I like to reduce my life in the format:

-1 = bad day (Daniel Powter)
0 = didn't leave bed
1 = productive (rest, recovery, work, family? or maybe FAITH > FAMILY > FRIENDS?)

# Life Retrospective

Back home after a day away with the parents at Serenbe Farms and then up to Dahlonega, GA around the square and then down to the Avalon to round out the day with some Antico pizza.

I sit here now at my childhood desk that my father has taken over with his business [Forest Economic Advisors, LLC](https://getfea.com/) who sell international forestry data. Along the car ride I'm talking to my parents about my new job at Anheuser-Busch InBev and how my role is dipping more and more into "product engineering" `insert link to blogpost here`. I'm building a platform currently for our Mexico market that we're referring to as "Global Marketplace Engine" (a PaaS) and our first customer is a local team on the ground in Mexico City, Mexico.

Life is good. Work is good. Career is good. Now time to focus on myself and what I want out of the next 50+ years of my life if I live the average lifespan of  76-78 years old. 26 + 50 = 76.

# Projects to Build

Projects that are still on the back-burner that I urgently want to work on:
- Grand Central
  - Vue + React on the same DOM with custom dep injection and routing
- Rust file stream transform
  - "cast from file/network to buffer to file/network and back again"
  - think of it like a mutex distributed programming system where you can data transform some GRPC/protobuf payload chunk by chunk and operate at maximum speed
- Street Prints
  - pick any location in the world, layer on water or streets or other locations and print out a wall poster like a giant "Fathead"
  - already live to an extent at https://cdbattaglia.com/one-square-mile
- Credcount
  - social media credibility ranker to use signals from Twitter and other social medias as markers for event identification
  - https://cdbattaglia.com/y-combinator
- Terna Fin
  - using EDGAR 10q's and 8k's along with market stock screeners to day trade using TD Ameritrade and Robinhood

# Project Categorization: Non-Profit (open source) vs Profit (closed source)

I want all of these projects to fall under two different categories:

1. Terna Technology, Inc. for all my projects that are in Greenfield but semi-proprietary

and

2. Down the Whole as a global network of individuals that like to humanistically build software, products and anything under the sun

More or less, DTW is for open source and Terna is an umbrella company. The goal will be to have _everything_ from Terna under DTW but similar to how Tesla did it by reaching critical mass in market before releasing their patents/IP. This isn't to say that I think I'm doing anything novel but since I'm working on a wide array of issues I don't want someone to beat me to market if I can help it.
